import PropTypes from 'prop-types';
import React from 'react';
import * as rmd from 'material-ui';
import config from 'cfg';
import { Link } from 'react-router';
import getGoogleApiClient from 'google-client-api';
import ArrowForward from 'material-ui/svg-icons/navigation/arrow-forward';
import _ from 'lodash';
import auth from 'dash-front/auth';
import IconCampaigns from 'material-ui/svg-icons/places/all-inclusive';
import IconCode from 'material-ui/svg-icons/action/code';
import IconSMBrowser from 'material-ui/svg-icons/social/share';
var COLORS = ['#F4013C', '#F46E02', '#3F51B5', '#E91E63'];
class Home extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            widgets: [],
            isLoading: true
        };

        this.loadData();
    }

    componentDidMount() {
        var user = this.context.user;

        getGoogleApiClient().then(gapi => {
            gapi.load('analytics', () => {
                // this.buildCharts(user.client, "view-selector-client", "timeline-client");
                this.buildCharts(gapi, user.username, 'view-selector-user', 'timeline-user');
            });
        });
    }

    loadData = () => {
        const token = auth.getAccessToken();
        if (!token) {
            return Promise.resolve(null);
        }
        return fetch(`${config.dash.api.host}/api/widgets?access_token=${token}`)
            .then(response => response.json())
            .then(body =>
                this.setState({
                    widgets: body.widgets,
                    isLoading: false
                })
            )
            .catch(err => {
                console.error(err);
                this.setState({ error: err, isLoading: false });
            });
    };

    static contextTypes = {
        user: PropTypes.object.isRequired
    };

    buildCharts = (gapi, path, viewSelectorContainer, chartContainer) => {
        return fetch(`${config.dash.api.host}/api/auth/google/token`)
            .then(response => response.json())
            .then(tokens => {
                gapi.analytics.auth.authorize({
                    serverAuth: {
                        access_token: tokens.access_token
                    }
                });

                var viewSelector = new gapi.analytics.ViewSelector({
                    container: viewSelectorContainer
                });
                viewSelector.execute();

                var dataChart = new gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:sessions, ga:pageviews, ga:users',
                        dimensions: 'ga:date',
                        filters: `ga:pagePath=@${path}`,
                        'start-date': '30daysAgo',
                        'end-date': 'yesterday'
                    },
                    chart: {
                        container: chartContainer,
                        type: 'LINE',
                        options: {
                            width: '100%'
                        }
                    }
                });
                viewSelector.on('change', function(ids) {
                    var newIds = {
                        query: {
                            ids: ids
                        }
                    };
                    dataChart.set(newIds).execute();
                });
            });
    };
    renderSocialSection = () => {
        let { user } = this.context;

        return (
            <section className="row blue-section section">
                <div className="container">
                    <div className="col-md-12">
                        <h3 className="section-header">Social Media Images</h3>
                    </div>

                    <div className="col-md-6">
                        <Link to={`/campaigns`}>
                            <rmd.Card className="home-info-card">
                                <rmd.CardText
                                    className="card-body"
                                    style={{ textAlign: 'center', backgroundColor: COLORS[3] }}
                                >
                                    <img src={`${config.assets}/assets/suggested.png`} />
                                    <p>Schedule automated posting of sport events to social channels </p>
                                </rmd.CardText>
                                <rmd.CardActions className="actions">
                                    <rmd.FlatButton className="create" label="Create an automated campaign" />
                                </rmd.CardActions>
                            </rmd.Card>
                        </Link>
                    </div>
                </div>
            </section>
        );
    };
    render() {
        var user = this.context.user;

        var isHTMLAllowed = user && _.get(user, 'permissions.htmlWidgets');
        var isSMAllowed = user && _.get(user, 'permissions.smWidgets');
        var isCampaignsAllowed = user && _.get(user, 'permissions.campaigns');

        var topWidgets = _.chain(this.state.widgets || [])
            .map(widget => {
                widget.lastWeekPageViews = (widget.lastWeekStats || []).reduce((sum, val) => sum + val.pageviews, 0);
                return widget;
            })
            .orderBy('lastWeekPageViews', 'desc')
            .slice(0, 5)
            .value();

        return (
            <div className="home">
                <section className="section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h3 className="section-header">Widgets</h3>
                            </div>
                            <div className={`col-md-4  ${!isHTMLAllowed && 'feature-disabled'}`}>
                                <Link to={`/widgets/pick`}>
                                    <rmd.Card className="home-info-card">
                                        <rmd.CardText
                                            className="card-body"
                                            style={{ textAlign: 'center', backgroundColor: COLORS[1] }}
                                        >
                                            <IconCode style={{ height: 88, width: 88, fill: '#fff' }} />
                                            <p>Create widget for website, integrate using embed code</p>
                                        </rmd.CardText>
                                        <rmd.CardActions className="actions">
                                            <rmd.FlatButton
                                                className="create"
                                                label="Create widget"
                                                labelPosition="before"
                                                icon={<ArrowForward style={{ width: '18px' }} />}
                                                primary
                                            />
                                        </rmd.CardActions>
                                    </rmd.Card>
                                </Link>
                            </div>

                            <div className={`col-md-4  ${!isSMAllowed && 'feature-disabled'}`}>
                                <Link to={`/sm/browser/football/tournaments/46`}>
                                    <rmd.Card className="home-info-card">
                                        <rmd.CardText
                                            className="card-body"
                                            style={{ textAlign: 'center', backgroundColor: COLORS[0] }}
                                        >
                                            <IconSMBrowser style={{ height: 88, width: 88, fill: '#fff' }} />
                                            <p>Find ready to publish Images with nice content</p>
                                        </rmd.CardText>
                                        <rmd.CardActions className="actions">
                                            <rmd.FlatButton
                                                className="create"
                                                label="Browse social images"
                                                labelPosition="before"
                                                icon={<ArrowForward style={{ width: '18px' }} />}
                                                primary
                                            />
                                        </rmd.CardActions>
                                    </rmd.Card>
                                </Link>
                            </div>

                            <div className={`col-md-4  ${!(isSMAllowed && isCampaignsAllowed) && 'feature-disabled'}`}>
                                <Link to={`/campaigns`}>
                                    <rmd.Card className="home-info-card">
                                        <rmd.CardText
                                            className="card-body"
                                            style={{ textAlign: 'center', backgroundColor: COLORS[3] }}
                                        >
                                            <IconCampaigns style={{ height: 88, width: 88, fill: '#fff' }} />
                                            <p>Automate posting sports content to social channels </p>
                                        </rmd.CardText>
                                        <rmd.CardActions className="actions">
                                            <rmd.FlatButton
                                                className="create"
                                                label="Create an automated campaign"
                                                labelPosition="before"
                                                icon={<ArrowForward style={{ width: '18px' }} />}
                                                primary
                                            />
                                        </rmd.CardActions>
                                    </rmd.Card>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="gray-section section" style={{ display: 'none' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h3 className="section-header">Featured resources</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h3 className="section-header">Analytics</h3>
                                <rmd.Card className="home-info-card">
                                    {/*<rmd.CardTitle
                                        title={`User stats: ${user.username}`}
                                    />*/}
                                    <div id="view-selector-user" style={{ display: 'none' }} />
                                    <div id="timeline-user" />
                                </rmd.Card>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="section gray-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h3 className="section-header">Usage</h3>
                                <rmd.Card className="home-info-card">
                                    <rmd.Table>
                                        <rmd.TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                            <rmd.TableRow>
                                                <rmd.TableHeaderColumn>WIID</rmd.TableHeaderColumn>
                                                <rmd.TableHeaderColumn>Widget Name</rmd.TableHeaderColumn>
                                                <rmd.TableHeaderColumn>Created</rmd.TableHeaderColumn>
                                                <rmd.TableHeaderColumn style={{ width: '40%' }}>
                                                    Locations
                                                </rmd.TableHeaderColumn>
                                                <rmd.TableHeaderColumn>Page views (last week)</rmd.TableHeaderColumn>
                                            </rmd.TableRow>
                                        </rmd.TableHeader>
                                        <rmd.TableBody displayRowCheckbox={false}>
                                            {this.state.isLoading && (
                                                <rmd.TableRow>
                                                    <rmd.TableRowColumn>Loading...</rmd.TableRowColumn>
                                                </rmd.TableRow>
                                            )}
                                            {!_.get(this.state.widgets, 'length') &&
                                                !this.state.isLoading && (
                                                    <rmd.TableRow>
                                                        <rmd.TableRowColumn>
                                                            No widget templates have been saved yet
                                                        </rmd.TableRowColumn>
                                                    </rmd.TableRow>
                                                )}
                                            {topWidgets.map(widget => {
                                                var locations = _.chain(widget.stats || [])
                                                    .sortBy(location => location.pageviews)
                                                    .reverse()
                                                    .slice(0, 3)
                                                    .map(row => {
                                                        return (
                                                            <a style={{ display: 'block' }} href={row.screenName}>
                                                                {row.screenName}
                                                            </a>
                                                        );
                                                    })
                                                    .value();

                                                return (
                                                    <rmd.TableRow key={widget._id}>
                                                        <rmd.TableRowColumn>{widget._id}</rmd.TableRowColumn>
                                                        <rmd.TableRowColumn>{widget.widgetName}</rmd.TableRowColumn>
                                                        <rmd.TableRowColumn>{widget.createdAt}</rmd.TableRowColumn>
                                                        <rmd.TableRowColumn style={{ width: '40%' }}>
                                                            {locations}
                                                        </rmd.TableRowColumn>
                                                        <rmd.TableRowColumn>
                                                            {widget.lastWeekPageViews}
                                                        </rmd.TableRowColumn>
                                                    </rmd.TableRow>
                                                );
                                            })}
                                        </rmd.TableBody>
                                    </rmd.Table>
                                    <rmd.CardActions style={{ textAlign: 'right' }}>
                                        <Link to={`/stats`}>
                                            <rmd.RaisedButton
                                                backgroundColor="#a4c639"
                                                style={{ marginRight: 15 }}
                                                onClick={this.saveFields}
                                            >
                                                See all
                                            </rmd.RaisedButton>
                                        </Link>
                                    </rmd.CardActions>
                                </rmd.Card>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Home;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/Home.js
 **/